const fr = {
    '/': {
        title: '{brand} | Paris Sportifs, Casino Live & Retraits Instantanés',
        description: 'Machines à sous, casino live & paris sportifs chez {brand}. Casino crypto avec retraits instantanés, jeux équitables & support 24/7.'
    },
    '/casino': {
        title: 'Casino en Ligne | Machines à Sous, Blackjack & Croupiers Live | {brand}',
        description: 'Machines à sous, blackjack, roulette & croupiers live chez {brand}. Des centaines de jeux, dépôts crypto rapides & retraits instantanés 24/7.'
    },
    '/sports': {
        title: 'Paris Sportifs en Ligne | Crypto Paris & Cotes | {brand}',
        description: 'Pariez sur le sport chez {brand}. Cotes compétitives sur le football, le basketball & plus. Paris en direct, mises crypto sécurisées & paiements rapides.'
    },
    '/livecasino': {
        title: 'Casino Live | Blackjack, Roulette & Croupiers en Direct | {brand}',
        description: 'Blackjack, roulette & jeux de casino live chez {brand}. Vrais croupiers, streaming HD & une large sélection de tables live disponibles 24/7.'
    },
    '/slots': {
        title: 'Machines à Sous en Ligne | Large Choix de Slots Casino | {brand}',
        description: 'Une immense collection de machines à sous chez {brand}. Machines classiques, vidéo slots & progressives - tous jouables en crypto.'
    },
    '/vip': {
        title: 'Programme VIP | Récompenses Exclusives & Avantages | {brand}',
        description: 'Le programme VIP de {brand} : récompenses exclusives, bonus personnalisés et assistance prioritaire. Avantages pour les joueurs fidèles.'
    },
    '/welcome-offer': {
        title: 'Offre de Bienvenue | Casino Crypto | {brand}',
        description: "Découvrez l'offre de bienvenue de {brand}. Commencez avec de la crypto et profitez d'avantages exclusifs pour les nouveaux joueurs."
    },
    '/referral': {
        title: 'Programme de Parrainage | Gagnez des Récompenses | {brand}',
        description: "Invitez vos amis sur {brand} et gagnez des récompenses lorsqu'ils s'inscrivent et remplissent les conditions."
    },
    '/promotion-page': {
        title: 'Promotions | Bonus & Offres Spéciales | {brand}',
        description: 'Toutes les promotions actives sur {brand}. Bonus, tours gratuits et offres spéciales pour les joueurs crypto.'
    },
    '/hotslots': {
        title: 'Slots Populaires | Machines à Sous les Plus Jouées | {brand}',
        description: 'Jouez aux machines à sous les plus populaires sur {brand}. Les meilleurs slots disponibles avec de la crypto.'
    },
    '/newgames': {
        title: 'Nouveaux Jeux | Derniers Jeux de Casino | {brand}',
        description: 'Découvrez les derniers jeux de casino sur {brand}. Nouveaux slots, jeux en direct et jeux de table ajoutés régulièrement.'
    },
    '/populargames': {
        title: 'Jeux Populaires | Les Jeux de Casino les Plus Joués | {brand}',
        description: 'Les jeux de casino les plus populaires sur {brand}. Des slots aux jeux en direct, tout disponible avec de la crypto.'
    },
    '/gameshows': {
        title: 'Jeux TV | Casino avec Shows en Direct | {brand}',
        description: 'Profitez des meilleurs jeux TV en direct sur {brand}. Présentateurs réels, jeux uniques et grands gains en temps réel.'
    },
    '/table_games': {
        title: 'Jeux de Table | Blackjack, Roulette & Baccarat | {brand}',
        description: "Jouez au blackjack, à la roulette, au baccarat et d'autres jeux de table sur {brand}. Tout disponible avec de la crypto."
    },
    '/hotlive': {
        title: 'Casino en Direct Populaire | Jeux en Direct les Plus Joués | {brand}',
        description: 'Les jeux de casino en direct les plus populaires sur {brand}. Jouez avec de vrais croupiers en temps réel.'
    },
    '/featurebuyin': {
        title: 'Slots avec Achat de Bonus | Feature Buy-in | {brand}',
        description: "Jouez à des slots avec la possibilité d'acheter le bonus sur {brand}. Accédez directement au tour bonus sans attendre."
    },
    '/originals': {
        title: 'Jeux de Casino Originaux | Titres Exclusifs | {brand}',
        description: 'Jouez à des jeux originaux exclusifs sur {brand}. Des titres uniques introuvables ailleurs, développés en interne pour une expérience de casino incomparable.'
    },
    '/providers': {
        title: 'Fournisseurs de Jeux | Studios Partenaires & Logiciels | {brand}',
        description: 'Explorez tous les fournisseurs de jeux sur {brand}. Nous collaborons avec les meilleurs studios pour vous offrir une bibliothèque crypto diversifiée et de haute qualité.'
    },
    '/about-us': {
        title: 'À Propos de Nous | En savoir plus sur {brand}',
        description: 'Découvrez {brand}, un casino crypto & sportsbook de premier plan. Engagé pour un jeu sécurisé, équitable & palpitant avec des retraits crypto instantanés.'
    },
    '/affiliate': {
        title: "Programme d'Affiliation | Gagnez de la Crypto avec {brand}",
        description: 'Devenez partenaire de {brand} & gagnez des commissions en promouvant notre casino crypto. Taux compétitifs, suivi en temps réel & support dédié aux affiliés.'
    },
    '/faq': {
        title: 'FAQ | Questions Fréquemment Posées | {brand}',
        description: "Trouvez des réponses aux questions courantes sur {brand}. Consultez notre FAQ pour obtenir de l'aide sur les comptes, paiements, bonus & jeux de casino."
    },
    '/aml-policy': {
        title: 'Politique LCB | Lutte Contre le Blanchiment chez {brand}',
        description: 'La politique LCB de {brand} garantit un environnement sécurisé et fiable. Découvrez nos mesures pour prévenir toute activité illicite sur notre plateforme.'
    },
    '/bonus-terms': {
        title: 'Conditions des Bonus | Promotions {brand}',
        description: 'Lisez les règles des bonus & promotions de {brand}. Apprenez comment réclamer, utiliser & retirer vos gains bonus sur notre plateforme.'
    },
    '/complaints-and-arbitration': {
        title: 'Réclamations et Arbitrage | Support Joueurs chez {brand}',
        description: 'Découvrez le processus de réclamation & résolution des litiges de {brand}. Nous garantissons un traitement équitable et résolvons les problèmes rapidement et en toute transparence.'
    },
    '/fairness': {
        title: 'Jeux Équitables Vérifiables | Garantie de Fairness chez {brand}',
        description: '{brand} utilise la technologie provably fair pour garantir que chaque résultat de jeu est vérifiable, transparent & totalement aléatoire.'
    },
    '/kyc-policy': {
        title: "Politique KYC | Vérification d'Identité chez {brand}",
        description: "La politique KYC de {brand} décrit notre processus de vérification d'identité. Découvrez comment nous protégeons les joueurs et maintenons un environnement de jeu sécurisé."
    },
    '/payment-policy': {
        title: 'Politique de Paiement | Dépôts & Retraits Crypto | {brand}',
        description: '{brand} accepte les dépôts & retraits en crypto. Lisez notre politique de paiement pour connaître les limites de transaction, les crypto acceptées & les délais de traitement.'
    },
    '/privacy-policy': {
        title: 'Politique de Confidentialité | Protection des Données chez {brand}',
        description: 'La politique de confidentialité de {brand}. Découvrez comment nous collectons, utilisons & protégeons vos données personnelles sur notre plateforme de casino crypto.'
    },
    '/responsible-gaming': {
        title: 'Jeu Responsable | Jouez en Toute Sécurité chez {brand}',
        description: '{brand} est engagé pour le jeu responsable. Accédez à des outils & ressources pour gérer vos habitudes de jeu et jouer en toute sécurité.'
    },
    '/terms-of-service': {
        title: "Conditions Générales d'Utilisation | {brand}",
        description: 'Consultez les conditions générales régissant votre utilisation de {brand}. Comprenez vos droits et responsabilités en tant que joueur.'
    },
    '/terms-sports': {
        title: 'Conditions des Paris Sportifs | {brand}',
        description: 'Les conditions des paris sportifs de {brand}. Règles pour placer des mises, encaisser les gains & utiliser le sportsbook sur notre plateforme.'
    }
};
export default fr;
